import React, { useState, useEffect} from 'react';
import { toast } from 'react-toastify'; // Or whatever toast library you use
import API_BASE_URL from '../../config'; // Using your project configuration path


const TableTDE = ({ field,item,setFetchAgain}) => {
    const [iseditable, setIseditable] = useState();
    const [iseditableid, setIseditableid] = useState("");
    const [editData, setEditData] = useState({});
    const [clickable, setClickable] = useState({});
    const [selectedid, setSelectedid] = useState([])
    const [batchaddition, setBatchaddition] = useState(true);

    const handeleditbutton = async (field, item, pressby) => {
    // 1. Check if we are SUBMITTING a change
    if (iseditable === field && pressby === "btn") {
        console.log("Click by btn")
        
        // Safety: Only check "Same Value" for single items, not batch strings
        if (iseditableid !== "batch" && editData[field] === item[field]) {
            toast.warning(`Same as Previous Value`);
            setIseditable("");
            setIseditableid();
            return; // Exit early
        }
        // 3. Handle Single Entry Update
        else {
            try {
                const response = await fetch(`${API_BASE_URL}/updateorder/${item._id}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ [field]: editData[field] })
                });
                if (response.ok) {
                    toast.success(`${field} Updated successfully!`);
                    setIseditable("");
                    setFetchAgain(prev => !prev);
                    // await getorders();
                    // if(typeof getphaseorders === 'function') getphaseorders(orders);
                    setEditData({});
                } else {
                    toast.error("Server Error by Backend");
                }
            } catch (error) {
                toast.error("Server Error");
            }
        }
    } 
    // 4. Handle First Click (Enabling Edit Mode)
    else {
        if (iseditable === field && (iseditableid === item._id || iseditableid === "batch")) {
            console.log("already editing");
        } else {
            // If item is "batch", it doesn't have [field], so we default to 0
            const initialVal = item === "batch" ? 0 : Number(item[field] || 0);
            setEditData({ ...editData, [field]: initialVal });
            setIseditable(field);
            setIseditableid(item._id ? item._id : item); // sets to "batch" or ID
            setClickable({ ...clickable, index: "clickable_index" });
            setTimeout(() => {
        // Construct a specific ID selector based on your component's ID
        // For TableTD, we will add an id attribute: id={`${field}-${item._id}`}
        const targetId = item === "batch" ? `batch-${field}` : `${field}-${item._id}`;
        const targetInput = document.getElementById(targetId);
        
        if (targetInput) {
            targetInput.focus();
            // scrollIntoView can be aggressive on iOS, only use if necessary
            targetInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, 150);
            console.log("first click");
        }
    }
};
    
    return (
        <td className={clickable?.[field]?.[item._id]}>
            <div className="input-group text-center d-flex justify-content-center flex-nowrap">
                {iseditableid === "batch" && editData[iseditable] > 0 && iseditable.slice(0, -5) === field && selectedid.includes(item._id) ? (
                    batchaddition ? (
                        <div className="d-flex justify-content-center align-items-center fw-normal small">
                            <span>{Number(item[field])}</span>
                            <span className="fw-bold ms-1" style={{ color: 'darkgreen' }}>
                                + {Number((editData[iseditable] / selectedid.length).toFixed(1))}
                            </span>
                        </div>
                    ) : (
                        <div className="d-flex justify-content-center align-items-center fw-normal">
                            <span className="fw-bold ms-1" style={{ color: 'darkgreen' }}>
                                {Number((editData[iseditable])).toFixed(1)}
                            </span>
                        </div>
                    )
                ) : (
                    <input
                        type={iseditableid === "batch" ? "text" : "number"}
                        /* Fixed: font-size 16px is MANDATORY for iOS to prevent zoom-glitch */
                        /* Added touch-action to improve tap responsiveness */
                        style={{ fontSize: '16px', touchAction: 'manipulation', minWidth: '60px' }}
                        className='form-control centerplaceholder no-spinner px-1 fw-bold'
                        aria-label={field}
                        placeholder={field}
                        value={iseditable === field && iseditableid === item._id ? editData[field] : (item[field] || 0)}
                        // readOnly={iseditable !== field && iseditableid !== item._id}
                        onClick={() => handeleditbutton(field, item, "inpt")}
                        /* Fixed: iOS Blur logic - use relatedTarget to see if we clicked the check button */
                        onBlur={(e) => {
                            if (!e.relatedTarget || !e.relatedTarget.classList.contains('checkbtn')) {
                                setTimeout(() => {
                                    setIseditable("");
                                    setIseditableid("");
                                }, 250);
                            }
                        }}
                        onChange={(e) => { setEditData({ ...editData, [field]: e.target.value }) }}
                    />
                )}
                {iseditable === field && iseditableid === item._id && (
                    <button
                        className="btn btn-outline-secondary checkbtn px-2"
                        type="button"
                        /* Important: relatedTarget check above depends on this button being focusable */
                        tabIndex="-1" 
                        onClick={() => handeleditbutton(field, item, "btn")}
                    >
                        <i className="bi bi-check-lg"></i>
                    </button>
                )}
            </div>
        </td>
    );
}

export default TableTDE;